import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import ChatInterface from './components/ChatInterface';
import LandingPage from './components/LandingPage';
import Header from './components/Header';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import ProtectedRoute from './components/auth/ProtectedRoute';
import NotFound from './components/NotFound';
import { AuthProvider } from './context/AuthContext';

const ChatPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #0A0A0A;
  color: white;
`;

const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

const MainSection = styled.main`
  flex: 1;
  padding: 20px;
  overflow-y: auto;
`;

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          
          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/chat" element={
              <ChatPageContainer>
                <Header />
                <ContentContainer>
                  <MainSection>
                    <ChatInterface />
                  </MainSection>
                </ContentContainer>
              </ChatPageContainer>
            } />
          </Route>
          
          {/* 404 Page Not Found */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
